import { connect } from 'react-redux';
import { goToLink } from 'redux-core/router/actions';

const mapDispatchToProps = {
  goToLink,
};

export default connect(undefined, mapDispatchToProps);
